// extracted by mini-css-extract-plugin
export default {"container":"Header_container__STE3d","header-full":"Header_header-full__uNbD2","header-short":"Header_header-short__Uxsqr"};